var map = {
	"./Logo.png": "5684",
	"./abt_img.jpg": "1dc3",
	"./banner-ver2.png": "09f9",
	"./banner.png": "1936",
	"./bg.jpg": "3625",
	"./eligble-icon.png": "2c2c",
	"./follow-up.png": "686e",
	"./follow1.png": "3f96",
	"./footer-logo.png": "8bef",
	"./ineligble-icon.png": "bfcd",
	"./lady.png": "5162",
	"./lb_logo2.png": "06a1",
	"./map-placeholder.png": "020a",
	"./micropscope.png": "cc2a",
	"./nav.jpg": "1482",
	"./nurse.png": "1b26",
	"./people.png": "fad1",
	"./rect.png": "325c",
	"./screening.png": "2f03",
	"./screening1.png": "288d",
	"./sea.jpg": "a4e0",
	"./sites.png": "b7f8",
	"./statsback.png": "0e91",
	"./treatment.png": "7f92",
	"./treatment1.png": "8a88",
	"./ui-dws-docs.png": "0a68",
	"./ui-dws-pp.png": "9062",
	"./.png": "2e87"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";